<div
  class="wrapper"
  [ngClass]="{ embed: embed, homescreen: homescreen, external: isExternalOrg }"
  [style.width]="width"
>
  <ul>
    <ng-container *ngFor="let item of links; let i = index; trackBy: trackByFn">
      <li
        *ngIf="
          !(item.featureFlag && featureFlags[item.featureFlag] !== true) &&
          !(item.removeFromProduction && isProduction)
        "
        class="parent"
        [ngClass]="{
          active: (item.children && showSubmenu.includes(i)) || item.isActive,
          'path-active': item.path && item.path === currentPath
        }"
      >
        <a
          *ngIf="isLoggedIn; else loginRedirect"
          [routerLink]="item.path"
          [ngClass]="{
            inactive: !item.path,
            current: item.children && showSubmenu.includes(i)
          }"
        >
          <div>
            <ng-icon [name]="item.icon" class="icon" size="18"></ng-icon>
            <span>{{ item.title }}</span>
          </div>
        </a>
        <ng-template #loginRedirect>
          <a
            (click)="showAuthModal()"
            class="inactive"
            [ngClass]="{
              current: item.children && showSubmenu.includes(i)
            }"
          >
            <div>
              <ng-icon [name]="item.icon" class="icon" size="18"></ng-icon>
              <span>{{ item.title }}</span>
            </div>
          </a>
        </ng-template>
        <ul *ngIf="item.children">
          <ng-container
            *ngFor="let subItem of item.children; trackBy: trackByFn"
          >
            <li
              *ngIf="
                !(!isLoggedIn && subItem.title === 'Logout') &&
                !(
                  subItem.featureFlag &&
                  featureFlags[subItem.featureFlag] !== true
                )
              "
            >
              <a
                *ngIf="!subItem.iframe"
                (click)="isLoggedIn ? null : showAuthModal()"
                [routerLink]="isLoggedIn ? subItem.path : null"
                [ngClass]="{ active: subItem.isActive }"
                (click)="
                  subItem.forceReload && subItem.isActive
                    ? reloadRoute(subItem.path)
                    : null
                "
              >
                <span>{{ subItem.title }}</span>
                <span *ngIf="!!subItem.badge" class="badge">{{
                  subItem.badge
                }}</span>
              </a>
              <a *ngIf="subItem.iframe" (click)="showIframeModal(subItem.path)">
                <span>{{ subItem.title }}</span>
                <span *ngIf="!!subItem.badge" class="badge">{{
                  subItem.badge
                }}</span>
              </a>
            </li>
          </ng-container>
        </ul>
        <!-- Hide on last item or show if showMenuLinks -->
        <hr *ngIf="i !== links.length - 1 || showMenuLinks" />
      </li>
    </ng-container>
    <li *ngIf="showMenuLinks">
      <ul>
        <li>
          <a
            *ngFor="let link of menuLinks"
            [href]="link.path"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{{ link.title }}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
